module.exports = __webpack_public_path__ + "img/delete.61a737ac.svg";